module.exports = __webpack_public_path__ + "media/cement_blocks_2.38f009b5.wav";